import { useEffect, FC } from 'react';

import { MetricsTracker, USER_EVENTS } from '..';

type PageMetricsProviderPropType = {
  pageId: string;
  pathname?: string;
  attributes?: Record<string, any>;
  GDPR: {
    hasGDPRConsent: boolean;
  };
  user: {
    id: string;
    package: string;
    email: string;
  };
  country?: string;
  children?: any;
};

const PageMetricsProvider: FC<PageMetricsProviderPropType> = ({
  pageId,
  pathname,
  attributes,
  GDPR,
  user,
  country,
  children,
}) => {
  const { hasGDPRConsent = false } = GDPR;
  const { id: userId = '1', package: packageId = '1', email = '' } = user;

  useEffect(
    () => {
      MetricsTracker.track({
        name: USER_EVENTS.PAGE_VIEW,
        data: {
          actionType: USER_EVENTS.PAGE_VIEW,
          actionFlow: pageId,
          pathname,
          pageId,
          attributes,
          data: {
            hasGDPRConsent,
            userId,
            packageId,
            email,
            country,
          },
        },
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      /**
       * Adding an empty array ensures that this is always and only called
       * on first page renders/reloads. SPA will never call this.
       */
    ]
  );

  return children;
};

export default PageMetricsProvider;
